import { Typography, useTheme } from 'hephaestus/web';

const TaxRank = ({ taxRank }: { taxRank: number }) => {
  const theme = useTheme();
  return (
    <span
      style={{
        background: theme.color.onSurface,
        width: '16px',
        height: '16px',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '2px',
        marginRight: '4px',
      }}
    >
      <Typography
        variant='bodySmall'
        component='span'
        sx={{ color: theme.color.surface, fontSize: '10px' }}
      >
        {taxRank}
      </Typography>
    </span>
  );
};

export default TaxRank;
